import React, { useState } from 'react';
import { parseScanned } from '../lib/gs1-parser.js';
import { isProduitCher } from '../lib/produits-chers.js';

export default React.memo(function PrepProduitsTab({ products, totalQty, loading, error, onRetry , photos, onControlPhoto, onPasTrouve = null, idsDeCote = [] }) {
  if (loading) return <div className="empty-state"><div className="empty-state-text">Chargement produits Odoo…</div></div>;

  if (error) return (
    <div style={{ padding: 12, borderRadius: 8, background: '#FDECEA', color: '#C0392B', fontSize: 12, marginBottom: 10 }}>
      Erreur : {error}<br /><br /><button className="btn btn-outline btn-sm" onClick={onRetry}>Réessayer</button>
    </div>
  );

  if (products.length === 0) return <div className="empty-state"><div className="empty-state-text">Aucun produit trouvé.</div></div>;

  return <ListeProduits products={products} totalQty={totalQty} photos={photos} onPasTrouve={onPasTrouve} idsDeCote={idsDeCote} />;
});

// Recherche : CIP, début du nom, ou bip de la boîte (DataMatrix → CIP).
function normaliser(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }

function ListeProduits({ products, totalQty, photos, onPasTrouve, idsDeCote }) {
  const [q, setQ] = useState('');
  const brut = q.trim();
  let cip = null;
  if (brut.length >= 12) { const s = parseScanned(brut); cip = s.cip13 || null; }
  const terme = normaliser(cip || brut);
  const visibles = !terme ? products : products.filter(p => {
    const n = normaliser(p.name || p.product_name);
    return n.includes(terme) || n.split(/[\s\[\]]+/).some(m => m.startsWith(terme));
  });
  return (
    <>
      {products.length > 5 && (
        <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#F2F3F7', paddingBottom: 6 }}>
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Chercher : CIP, début du nom, ou bipe la boîte"
            style={{ width: '100%', padding: '11px 12px', borderRadius: 10, border: '1.5px solid ' + (q ? '#1A5276' : '#E2E2E8'), fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }} />
          {q && <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#6B7280', marginTop: 3 }}>
            <span>{visibles.length} produit{visibles.length > 1 ? 's' : ''} sur {products.length}{cip ? ' (CIP ' + cip + ')' : ''}</span>
            <button onClick={() => setQ('')} style={{ background: 'none', border: 'none', color: '#C0392B', fontSize: 11, fontWeight: 700, cursor: 'pointer', padding: 0 }}>Effacer ✕</button>
          </div>}
        </div>
      )}
      {q && !visibles.length && <div style={{ fontSize: 12, color: '#C0392B', padding: 8 }}>Aucun produit de cette commande ne correspond.</div>}
      {visibles.map((p) => {
        const idx = products.indexOf(p);
        const cher = isProduitCher(p);
        const controlDone = cher && (photos || []).some(ph => String(ph.control_product_id) === String(p.id));
        return (
        <div key={p.id} style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
          background: cher ? '#FDFAF4' : 'white',
          border: cher ? '1.5px solid #b5904a' : '1px solid #E8E8EE', borderRadius: 10, marginBottom: 4,
        }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#F2F3F7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#888', flexShrink: 0 }}>{idx + 1}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{p.name || p.product_name || '?'}</div>
            {(p.orders || []).length > 1 && <div style={{ fontSize: 10, color: '#999', marginTop: 2 }}>{(p.orders || []).join(' + ')}</div>}
            {onPasTrouve && (idsDeCote.includes(String(p.id))
              ? <div style={{ fontSize: 10.5, fontWeight: 700, color: '#D97706', marginTop: 3 }}>⚠️ À reprendre (encadré orange)</div>
              : <button onClick={() => onPasTrouve(p)} style={{ marginTop: 4, padding: '3px 8px', borderRadius: 6, border: '1px solid #D97706', background: '#FFFBEB', color: '#92400E', fontSize: 10.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Je ne trouve pas</button>)}
            {cher && (
              <div style={{ fontSize: 9, fontWeight: 800, color: controlDone ? '#16A34A' : '#b5904a', marginTop: 2 }}>
                {controlDone ? '✓ Photo du produit dans la caisse prise' : 'PRODUIT SENSIBLE : photo du produit dans la caisse à prendre (étape Photos)'}
              </div>
            )}
          </div>
          {cher && controlDone && <span style={{ fontSize: 16, flexShrink: 0 }}>✅</span>}
          <div style={{ minWidth: 48, textAlign: 'center', padding: '6px 10px', borderRadius: 8, background: cher ? '#FDFAF4' : '#EEF6FF', fontSize: 16, fontWeight: 800, color: cher ? '#8a6a30' : '#1A5276', flexShrink: 0 }}>{p.total_qty}</div>
        </div>
        );
      })}

      <div style={{ marginTop: 8, padding: '10px 14px', background: '#18181A', borderRadius: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: '#999', fontSize: 12, fontWeight: 600 }}>TOTAL — {products.length} produit{products.length > 1 ? 's' : ''}</span>
        <span style={{ color: 'white', fontSize: 18, fontWeight: 800 }}>{totalQty} boîtes</span>
      </div>
    </>
  );
}
